
export const SET_CUSTOMER = "CLEAR_COMMON_STATE";
export const SAVE_PRESCRIPTION = "SAVE_PRESCRIPTION";
export const SET_CONSENT_CHECKBOX = "SET_CONSENT_CHECKBOX";
export const CLEAR_CONSENT_CHECKBOX = "CLEAR_CONSENT_CHECKBOX";
export const CLEAR_CUSTOMER_STATE = "CLEAR_CUSTOMER_STATE";
export const SET_PAGE_NAME = "SET_PAGE_NAME";
export const SET_DOCTOR_DETAILS = "SET_DOCTOR_DETAILS"

